//천단위마다 콤마+소수점 미표시
export function formatNumber(num) {
    num = Math.floor(num); // convert number to integer by rounding down
    const parts = num.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

var tie_arr=[];

export function tie_init(){
    tie_arr=[];
}
export function tie_in(){
    return tie_arr;
}
export function tie_add(order){
    tie_arr.push(order);
}
export function tie_includes(order){
    if(tie_arr.includes(order))
    {
        return true;
    }
    else
    {
        return false;
    }
}

export function GetUrl(){
    //return 'http://13.208.99.210:5800/';
    //return 'http://localhost:5000/';
    //return 'https://210.223.56.219:2100/';
    return 'https://api.e-fit.info/';
}

export function GetMaintenanceUrl(){
    //return 'http://localhost:5500/';
    //return 'http://13.208.99.210:5500/';
    //return 'https://210.223.56.219:2200/';
    return 'https://mt.e-fit.info/';
}
  export function CTicksToDateString(ticks) {
        // C# Ticks 기준점에서 1970-01-01까지의 Ticks 차이
        const epochTicks = 621355968000000000;

        // C# Ticks를 밀리초로 변환
        const milliseconds = (ticks - epochTicks) / 10000;

        const addmilliseconds = 9 * 60 * 60 * 1000; 

        // JavaScript Date 객체 생성
        const date = new Date(milliseconds + addmilliseconds);

        // UTC 시간으로 변환하여 출력
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const TICKS_TO_UNIX_EPOCH_MS = 62135596800000;
const TICKS_PER_MILLISECOND = 10000;

  export function formatTotalTime(totalMilliseconds) {

    // 시간, 분, 초, 밀리초 계산
    let hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
    let minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    //let seconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
    let milliseconds = totalMilliseconds % 1000;

    if(milliseconds !== 0)
    {
        minutes = minutes + 1;
    }

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${formattedHours}H ${formattedMinutes}M`;
}

  export function CTicksToDateStringRemainTime(ticks) {
    if(ticks <= 0)
    {
        return `00H 00M`;
    }
    const milliseconds = ticks / TICKS_PER_MILLISECOND;

    // Unix epoch 기준으로 변환
    //const timestamp = milliseconds - TICKS_TO_UNIX_EPOCH_MS;
    
    // JavaScript Date 객체 생성
    const date = new Date(milliseconds);

    return formatTotalTime(date.getTime());

}

